
export function getSkippedItems(currentPage: number, pageSize: number): number {
    return (currentPage - 1) * pageSize;
}